var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPathVueJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8576 8L60 32L46.1424 8H0L60 111.925L120 8H73.8576Z",
    fill: "#4DBA87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8576 8L60 32L46.1424 8H24L60 70.352L96 8H73.8576Z",
    fill: "#435466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 103.925,
    fill: "white",
    transform: "translate(0 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathVueJs);
export default __webpack_public_path__ + "static/media/path-vue-js.9c27a0ae2557519dc22be9293947e97d.svg";
export { ForwardRef as ReactComponent };